export const filterStringNumbers = (phone: string) => {
  return phone
    .split("")
    .filter((char) => !isNaN(parseInt(char)))
    .join("");
};
